import { Box, Typography } from '@mui/material'
import { useContext } from 'react'

import Button from '@/components/base/Button'
import useTrans from '@/hooks/useTrans'

import { WrappedTokensFlowContext } from '../context'

const Container = ({ onClose }: { onClose: () => void }) => {
  const trans = useTrans()
  const { selectedToken } = useContext(WrappedTokensFlowContext)

  if (!selectedToken) return null

  const tokenSymbol = selectedToken.symbol
  const displaySymbol = selectedToken.displaySymbol
  const urlUnwrapToken = `https://wrap.renec.org/unwrap-token/${selectedToken.symbol}`

  return (
    <Box>
      <Typography className="text-sm">{trans.wrapped_token.info_wrapped_token(displaySymbol, tokenSymbol)}</Typography>
      <Typography className="text-sm mt-3">{trans.wrapped_token.info_unwrap_token(displaySymbol, tokenSymbol)}<a href={urlUnwrapToken} target="_blank" rel="noopener noreferrer">{urlUnwrapToken}</a></Typography>
      <Button
        onClick={onClose}
        data-testid="btn-close"
        className="mt-6"
        variant="outlined"
        size="xl"
        fullWidth
      >{trans.wrapped_token.btn_got_it}</Button>
    </Box>
  )
}

export default Container
